export var CreateModel;
(function (CreateModel) {
    CreateModel["Normal"] = "1";
    CreateModel["Simplify"] = "2";
    CreateModel["Direct"] = "3";
})(CreateModel || (CreateModel = {}));
